// Brand-colored service badge (icon inside its brand-color chip)
// Usage: <ServiceIcon code="wa" size="md" />

const ICONS = {
  wa: {
    bg: "#25D366",
    svg: (
      <svg viewBox="0 0 24 24" fill="white" className="w-full h-full p-1.5">
        <path d="M20.5 3.5A11 11 0 0 0 3.6 17.7L2 22l4.4-1.6A11 11 0 1 0 20.5 3.5Zm-8.5 17a9 9 0 0 1-4.6-1.3l-.3-.2-2.6.9.9-2.5-.2-.4A9 9 0 1 1 12 20.5Zm5-6.7c-.3-.1-1.7-.8-2-.9-.3-.1-.5-.1-.7.1s-.8 1-1 1.2c-.2.2-.3.2-.6.1a7.4 7.4 0 0 1-3.6-3.2c-.3-.5.3-.4.8-1.4a.5.5 0 0 0 0-.5c0-.1-.7-1.7-.9-2.3-.2-.6-.5-.5-.7-.5h-.6a1.1 1.1 0 0 0-.8.4 3.4 3.4 0 0 0-1 2.5 5.9 5.9 0 0 0 1.2 3.1 13.5 13.5 0 0 0 5.1 4.5c.7.3 1.3.5 1.8.6a4.2 4.2 0 0 0 1.9.1 3.1 3.1 0 0 0 2-1.4 2.5 2.5 0 0 0 .2-1.4c-.1-.2-.3-.2-.6-.4Z"/>
      </svg>
    ),
  },
  tg: {
    bg: "#26A5E4",
    svg: (
      <svg viewBox="0 0 24 24" fill="white" className="w-full h-full p-1.5">
        <path d="M21.9 4.5 2.7 12a.7.7 0 0 0 0 1.3l4.9 1.6 1.9 6.1a.7.7 0 0 0 1.2.3l2.7-2.8 5 3.7a.7.7 0 0 0 1.1-.4l3-16.1a.7.7 0 0 0-.9-.7Zm-3 3.6-8.7 7.9-.3 3.4L8.4 14 18.3 8Z"/>
      </svg>
    ),
  },
  ig: {
    bg: "linear-gradient(45deg,#f09433,#e6683c 25%,#dc2743 50%,#cc2366 75%,#bc1888)",
    svg: (
      <svg viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2" className="w-full h-full p-1.5">
        <rect x="3" y="3" width="18" height="18" rx="5"/><circle cx="12" cy="12" r="4"/><circle cx="17.5" cy="6.5" r="1" fill="white"/>
      </svg>
    ),
  },
  fb: {
    bg: "#1877F2",
    svg: (
      <svg viewBox="0 0 24 24" fill="white" className="w-full h-full p-1.5">
        <path d="M13 22v-8h3l1-4h-4V7.5c0-1.1.3-2 2-2h2V2h-3.5C10.4 2 9 3.4 9 6v4H6v4h3v8Z"/>
      </svg>
    ),
  },
  go: {
    bg: "white",
    svg: (
      <svg viewBox="0 0 24 24" className="w-full h-full p-1.5">
        <path fill="#4285F4" d="M23 12.3c0-.8-.1-1.6-.2-2.3H12v4.4h6.2c-.3 1.5-1.1 2.7-2.4 3.5v2.9h3.9c2.3-2.1 3.6-5.2 3.6-8.5Z"/>
        <path fill="#34A853" d="M12 23c3.2 0 6-1.1 7.9-2.9l-3.9-2.9c-1 .7-2.4 1.2-4 1.2-3 0-5.6-2-6.5-4.8H1.4v3C3.4 20.5 7.4 23 12 23Z"/>
        <path fill="#FBBC05" d="M5.5 13.6a6.6 6.6 0 0 1 0-4.2v-3H1.4a11 11 0 0 0 0 10.2Z"/>
        <path fill="#EA4335" d="M12 5.4c1.7 0 3.2.6 4.4 1.8l3.4-3.4C17.9 2 15.2 1 12 1 7.4 1 3.4 3.5 1.4 7.4l4.1 3c1-2.9 3.5-4.9 6.5-5Z"/>
      </svg>
    ),
  },
  tw: {
    bg: "#000",
    svg: (
      <svg viewBox="0 0 24 24" fill="white" className="w-full h-full p-1.5">
        <path d="M18.9 2H22l-7.1 8.1L23 22h-6.8l-5.3-6.9L4.7 22H1.6l7.6-8.7L1 2h6.9l4.8 6.3Zm-1.2 18h1.9L7.4 4H5.4Z"/>
      </svg>
    ),
  },
  ds: {
    bg: "#5865F2",
    svg: (
      <svg viewBox="0 0 24 24" fill="white" className="w-full h-full p-1.5">
        <path d="M19.3 4.4A19 19 0 0 0 15 3l-.2.4a17.6 17.6 0 0 0-5.6 0L9 3a19 19 0 0 0-4.3 1.4A20 20 0 0 0 1 15.5a19 19 0 0 0 5.7 2.9l.4-.5a13 13 0 0 1-2-1l.5-.4a13.5 13.5 0 0 0 12.8 0l.5.4a13 13 0 0 1-2 1l.4.5A19 19 0 0 0 23 15.5a20 20 0 0 0-3.7-11.1ZM8.6 13.7c-1 0-1.9-1-1.9-2.1 0-1.2.8-2.1 1.9-2.1s1.9 1 1.9 2.1c0 1.2-.9 2.1-1.9 2.1Zm6.8 0c-1 0-1.9-1-1.9-2.1 0-1.2.8-2.1 1.9-2.1s1.9 1 1.9 2.1c0 1.2-.9 2.1-1.9 2.1Z"/>
      </svg>
    ),
  },
  am: {
    bg: "#FF9900",
    svg: (
      <svg viewBox="0 0 24 24" fill="black" className="w-full h-full p-1.5">
        <path d="M4 16.5c4.6 3 10.9 3.4 15.9.5l.5.7c-4.7 4-11.5 3.7-16.8-.1Zm17.5-1.9c.3.4-.4 2.3-1 3.1-.2.3-.4.2-.3-.1.3-.8.9-2.5.6-2.9-.3-.4-1.8-.2-2.5-.1-.2 0-.2-.2-.1-.3 1.2-.9 3-.6 3.3.3ZM10.6 8.2C10.2 6 11.7 4.7 13.4 4.7c1.9 0 3.6 1 3.6 3.6v3.2c0 .7.2 1 .6 1.4.2.1.2.4 0 .5l-1.4 1.2a.5.5 0 0 1-.5 0 4 4 0 0 1-1-1.2c-1 1-1.7 1.3-3 1.3s-2.5-.9-2.5-2.7c0-1.5.7-2.4 1.7-2.9 1-.5 2.3-.6 3.5-.7v-.3c0-.7 0-1.4-.4-1.8s-1-.3-1.3-.3c-.9 0-1.7.4-1.8 1.4 0 .2-.1.4-.4.4l-1.6-.2c-.3 0-.4-.2-.4-.4Zm2.6 3.7c0 .8.4 1.1 1.1 1.1a1.5 1.5 0 0 0 1.3-.7c.3-.5.3-1 .3-1.5v-.4c-1.7 0-2.7.3-2.7 1.5Z"/>
      </svg>
    ),
  },
  mm: {
    bg: "white",
    svg: (
      <svg viewBox="0 0 24 24" className="w-full h-full p-1.5">
        <rect x="2" y="2" width="9.5" height="9.5" fill="#F25022"/>
        <rect x="12.5" y="2" width="9.5" height="9.5" fill="#7FBA00"/>
        <rect x="2" y="12.5" width="9.5" height="9.5" fill="#00A4EF"/>
        <rect x="12.5" y="12.5" width="9.5" height="9.5" fill="#FFB900"/>
      </svg>
    ),
  },
  ot: {
    bg: "#334155",
    svg: (
      <svg viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="w-full h-full p-1.5">
        <circle cx="12" cy="12" r="10"/><line x1="2" y1="12" x2="22" y2="12"/>
        <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"/>
      </svg>
    ),
  },
};

const SIZES = {
  xs: "w-6 h-6 rounded-md",
  sm: "w-8 h-8 rounded-lg",
  md: "w-11 h-11 rounded-xl",
  lg: "w-14 h-14 rounded-2xl",
};

export function ServiceIcon({ code, size = "md" }) {
  const item = ICONS[code] || ICONS.ot;
  const cls = SIZES[size] || SIZES.md;
  const style = item.bg.startsWith("linear")
    ? { backgroundImage: item.bg }
    : { backgroundColor: item.bg };
  return (
    <div className={`${cls} flex items-center justify-center overflow-hidden shadow-md`} style={style}>
      {item.svg}
    </div>
  );
}
